import React from 'react'

import {checkRegisteredCheck} from "../utils/request";
import BaseLayout from "./BaseView/BaseLayout";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import storage from "../utils/storage";
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import LoadingCard from "./components/LoadingCard";
import intl from "react-intl-universal";


class RegisteredCheck extends React.Component {

	constructor(props) {
		super(props);
		const key = this.props.match.params.key;

		this.state = {};

		document.title = intl.get('verify_email') + " - RobinAlgo";

		setTimeout(() => {
			this.toCheckRegisteredCheck(key)
		}, 1000);

		this.checkUserStatus()
	}

	checkUserStatus = () => {
		if (storage.get('token') === null || storage.get('token') === undefined) {

		} else {
			this.props.history.push('/account');
		}
	};

	toCheckRegisteredCheck = (key) => {

		checkRegisteredCheck(key).then(res => {
			// alert(JSON.stringify(res))
			if (res.data.attestSuccess) {
				this.props.history.push('/login/701');
			} else {
				this.props.history.push('/login/702');
			}
		})
	};


	render() {
		return (
			<BaseLayout>

				<GridContainer justify="center"  alignItems="center">
					<GridItem xs={12} sm={12} md={6}>
						<LoadingCard type={6}/>

						<h3>
							<CircularProgress
								color={'#fff'}/>
							&nbsp;&nbsp;&nbsp;&nbsp;{intl.get('verify_email_info')}
						</h3>
					</GridItem>


				</GridContainer>

			</BaseLayout>
		)
	}
}

export default RegisteredCheck
